<template>
  <div class="analytics-index">

    <div class="analytics-ul">
      <router-link
        v-if="available_reports.JOB && role === 'admin'"
        :to="`/dashboard/analytics/plan`"
        class="analytics-li"
      >
        Сводка по видам работ
        <i class="fas fa-chevron-right"></i>
      </router-link>
      <router-link
        v-if="available_reports.JOB"
        :to="`/dashboard/analytics/job`"
        class="analytics-li"
      >
        Сводка по работам (план\факт) <i class="fas fa-chevron-right"></i>
      </router-link>

      <router-link

        v-if="available_reports.JOB && (!$store.getters.permission.price_ignore || role=== 'admin') && $store.getters.permission.price"
        :to="`/dashboard/analytics/job-price`"
        class="analytics-li"
      >
        Сводка по стоимости работ (план\факт) <i class="fas fa-chevron-right"></i>
      </router-link>
      <router-link
        v-if="available_reports.PROF"
        :to="`/dashboard/analytics/amount`"
        class="analytics-li"
      >
        Сводка по численности <i class="fas fa-chevron-right"></i>
      </router-link>
      <router-link
        v-if="available_reports.TECH"
        :to="`/dashboard/analytics/construction-engineering`"
        class="analytics-li"
      >
        Сводка по технике <i class="fas fa-chevron-right"></i>
      </router-link>
      <a
        @click="openDialog = true"
        class="analytics-li"
      >
        Сводка по отчетам
        <i class="fas fa-chevron-right"></i>
      </a>
      <router-link
        v-if="available_reports.PROF && role === 'admin'"
        :to="`/dashboard/analytics/performance`"
        class="analytics-li"
      >
        Сводка по производительности <i class="fas fa-chevron-right"></i>
      </router-link>
      <router-link
        v-if="available_reports.WILD_PIPE && role === 'admin'"
        :to="`/dashboard/analytics/welding`"
        class="analytics-li"
      >
        Сводка по трубопроводам <i class="fas fa-chevron-right"></i>
      </router-link>
    </div>


    <el-dialog
      @close="closeDialog"
      title="Выгрузить отчет"
      :visible.sync="openDialog"
      width="30%"
      center
    >
      <div>
        <date-picker
          ref="datePicker"
          placeholder="Фильтр по дате"
          v-model="datetimeRangeDownload"
          range
        ></date-picker>
        <el-row>
          <el-col :span="12">
            <el-checkbox v-model="isTurn" style="margin-top: 10px">По Сменам</el-checkbox>
          </el-col>
          <el-col :span="12">
            <el-checkbox v-model="isUser" style="margin-top: 10px">По пользователям</el-checkbox>
          </el-col>
        </el-row>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">Закрыть</el-button>
        <a :href="getHref" target="_blank">
          <el-button type="primary" @click="closeDialog">Выгрузить</el-button>
        </a>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getRole} from "../../../firestore/permission";
import dayjs from "dayjs";
import {apiUrl, isApiRuleIgnore} from "../../../plugins/firebase";
import firebase from "firebase";
import DatePicker from 'vue2-datepicker';

export default {
  name: 'Index',
  components: {DatePicker},
  data() {
    return {
      role: 'worker',
      datetimeRangeDownload: [
        new Date(String(dayjs().utc().subtract(1, 'month').format('YYYY-MM-DD'))),
        new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
      ],
      isTurn: false,
      isUser: false,
      openDialog: false,
      available_reports: {
        JOB: true,
        TECH: true,
        PROF: true,
        COVID: true,
        WILD_PIPE: false,
        MATERIALS: false,
        MAIN: false,
      },
    }
  },
  async mounted() {
    const available_reports = this.$store.state.project.available_reports || {};
    if (this.available_reports) {
      this.available_reports = {
        ...this.available_reports,
        ...available_reports,
      };
    }

    this.role = await getRole(this.$store.state.project.id);
  },
  computed: {
    getHref() {
      let path = '';

      if (this.isTurn) {
        path += ', isTurn=true'
      }

      if (this.isUser) {
        path += ', isUser=true'
      }

      let params = encodeURIComponent(`/onGenerateMissingReports/${this.$store.state.project.id}`)

      if(isApiRuleIgnore) {
        params = `/onGenerateMissingReports/${this.$store.state.project.id}`
      }

      let url = `${apiUrl}${params}&queryParams=uid=${authFirestore.currentUser.uid}${path}`;
      if (isApiRuleIgnore) {
        const params = `/onGenerateMissingReports/${this.$store.state.project.id}`
        url = `${apiUrl}${params}&queryParams=uid=${authFirestore.currentUser.uid}${path}`;
      }
      url += `, fromDate=${dayjs(this.datetimeRangeDownload[0]).format('YYYY-MM-DD')}, toDate=${dayjs(this.datetimeRangeDownload[1]).format('YYYY-MM-DD')}`;


      if (isApiRuleIgnore) {
        url = url.replace('&queryParams=', '?').replace(/, /g, "&")
      }

      console.log(url, 'url')

      return url;
    },
  },
  methods: {
    closeDialog() {
      setTimeout(() => {
        this.openDialog = false;
      }, 500);
    },
  }
};
</script>

<style scoped lang="scss">
.analytics-index {
  margin: 0 auto;
  max-width: 400px;
  padding-top: 20px;
}


.analytics-ul {
  text-align: left;
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .analytics-li, > > > .analytics-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;
    text-decoration: none;
    color: #000;

    &.active {
      background: rgba(54, 118, 203, 0.26) !important;
    }

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Analytics/Summary.vue